import { fetchEmployees, selectEmployees, selectEmployeesBlockStatus, selectEmployeesCurrentGroup, selectEmployeesCurrentPage, selectEmployeesFirstLoad, selectEmployeesLoading, selectEmployeesSearch, selectEmployeesTotalCount, selectEmployeesTotalPages, setEmployeesBlockStatus, setEmployeesPage, setEmployeesSearch } from "@/entities/user"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { UsersFilters } from "@/widgets/users-filters"
import { UsersTable } from "@/widgets/users-table"
import { useEffect, useRef } from "react"

export const EmployeesListPage = () => {
    const isFirstRender = useRef(true)
    const usersFirstLoad = useAppSelector(selectEmployeesFirstLoad)
    const page = useAppSelector(selectEmployeesCurrentPage)
    const totalPages = useAppSelector(selectEmployeesTotalPages)
    const group = useAppSelector(selectEmployeesCurrentGroup)
    const isLoading = useAppSelector(selectEmployeesLoading)
    const users = useAppSelector(selectEmployees)
    const totalCount = useAppSelector(selectEmployeesTotalCount)
    const search = useAppSelector(selectEmployeesSearch)
    const blockStatus = useAppSelector(selectEmployeesBlockStatus)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchEmployees())
        }
    }, [page, group, search, blockStatus])

    useEffect(() => {
        if (usersFirstLoad) {
            dispatch(fetchEmployees())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="сотрудники" />
            <div className="flexbox">
                <PageSubtitle title="список сотрудников" />
                <UsersFilters
                    search={search}
                    setSearch={(query) => dispatch(setEmployeesSearch(query))}
                    blockStatus={blockStatus}
                    setBlockStatus={(value) => dispatch(setEmployeesBlockStatus(value))}
                />
                <UsersTable
                    page={page}
                    totalPages={totalPages}
                    users={users}
                    isLoading={isLoading}
                    totalCount={totalCount}
                    setPage={(page) => dispatch(setEmployeesPage(page))}
                    onAccrual={() => dispatch(fetchEmployees())}
                    labelNoInfo="Нет данных о сотрудниках"
                />
            </div>
        </div>
    )
}